var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigidBigIdIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.153 17.4725C97.1926 17.4725 50.5499 41.7396 33.5986 53.8731C33.5986 98.3032 45.9106 195.728 144.942 243.906C244.508 191.446 258.783 99.7307 255.214 53.8731C240.761 41.7396 199.114 17.4725 148.153 17.4725Z",
    fill: "#F4F4F4",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.859 22.8253C107.899 22.8253 61.2559 47.0924 44.3047 59.2259C44.3047 103.656 56.6166 201.081 155.648 249.258C255.214 196.799 269.489 105.083 265.92 59.2259C251.467 47.0924 209.82 22.8253 158.859 22.8253Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.84 59.7611L33.5986 54.4081",
    stroke: "#222222",
    strokeWidth: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_502_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.4795 158.397C77.4871 162.333 79.6411 166.165 81.9205 169.933C96.3082 167.253 107.726 159.632 116.28 148.452C122.344 140.538 134.222 149.646 128.158 157.581C118.141 170.666 105.614 179.313 90.9547 183.354C92.8995 185.992 94.9489 188.588 97.0611 191.121C105.614 188.044 111.867 185.217 116.719 182.809C123.85 179.313 133.783 172.467 142.002 172.467C145.85 172.467 149.99 173.409 154.298 174.686C174.688 180.841 192.129 188.734 212.999 192.65C215.363 189.865 217.621 187.039 219.796 184.128C161.743 172.76 120.065 142.653 120.065 86.3541C120.065 67.8043 127.28 46.0929 153.127 46.0929C174.04 46.0929 180.773 59.9949 186.483 76.472C198.361 110.745 213.836 121.339 249.952 121.067C254.594 103.103 256.769 83.9255 256.267 63.7635C250.955 59.4505 244.159 55.2841 236.275 51.5365C238.262 57.6081 240.102 63.9728 241.796 70.6726C244.264 80.3453 229.75 84.0511 227.304 74.3784C224.459 63.1982 221.281 53.1486 217.809 44.1458C212.226 42.2825 206.328 40.6075 200.243 39.1838C216.931 61.9629 210.051 95.8385 239.851 90.3531C249.659 88.5525 252.357 103.292 242.549 105.092C179.916 116.587 218.353 34.5778 152.939 34.5778C116.802 34.5778 108.709 63.4704 108.709 91.8396C108.709 100.047 110.048 108.442 110.048 114.807C110.048 136.937 96.4546 153.351 75.4795 158.397Z",
    fill: "#FBF7FF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4795 158.397C77.4871 162.333 79.6411 166.165 81.9205 169.933C96.3082 167.253 107.726 159.632 116.28 148.452C122.344 140.538 134.222 149.646 128.158 157.581C118.141 170.666 105.614 179.313 90.9547 183.354C92.8995 185.992 94.9489 188.588 97.0611 191.121C105.614 188.044 111.867 185.217 116.719 182.809C123.85 179.313 133.783 172.467 142.002 172.467C145.85 172.467 149.99 173.409 154.298 174.686C174.688 180.841 192.129 188.734 212.999 192.65C215.363 189.865 217.621 187.039 219.796 184.128C161.743 172.76 120.065 142.653 120.065 86.3541C120.065 67.8043 127.28 46.0929 153.127 46.0929C174.04 46.0929 180.773 59.9949 186.483 76.472C198.361 110.745 213.836 121.339 249.952 121.067C254.594 103.103 256.769 83.9255 256.267 63.7635C250.955 59.4505 244.159 55.2841 236.275 51.5365C238.262 57.6081 240.102 63.9728 241.796 70.6726C244.264 80.3453 229.75 84.0511 227.304 74.3784C224.459 63.1982 221.281 53.1486 217.809 44.1458C212.226 42.2825 206.328 40.6075 200.243 39.1838C216.931 61.9629 210.051 95.8385 239.851 90.3531C249.659 88.5525 252.357 103.292 242.549 105.092C179.916 116.587 218.353 34.5778 152.939 34.5778C116.802 34.5778 108.709 63.4704 108.709 91.8396C108.709 100.047 110.048 108.442 110.048 114.807C110.048 136.937 96.4546 153.351 75.4795 158.397Z",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_502_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.162 221.354C137.38 227.446 146.226 232.974 155.658 237.915C162.496 234.335 174.792 226.693 175.211 226.253C173.078 225.311 171.53 224.704 170.547 224.264C162.851 220.893 154.863 216.894 146.372 216.203C144.156 216.036 141.897 216.162 139.743 216.748C137.757 217.292 135.854 218.109 134.013 219.009C133.072 219.47 132.11 219.951 131.169 220.412C130.96 220.516 129.35 221.5 129.141 221.354H129.162Z",
    fill: "#FBF7FF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.162 221.354C137.38 227.446 146.226 232.974 155.658 237.915C162.496 234.335 174.792 226.693 175.211 226.253C173.078 225.311 171.53 224.704 170.547 224.264C162.851 220.893 154.863 216.894 146.372 216.203C144.156 216.036 141.897 216.162 139.743 216.748C137.757 217.292 135.854 218.109 134.013 219.009C133.072 219.47 132.11 219.951 131.169 220.412C130.96 220.516 129.35 221.5 129.141 221.354H129.162Z",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_502_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.37 202.49C110.34 205.484 113.414 208.415 116.613 211.221L118.558 210.278C125.689 206.761 134.347 200.585 142.566 200.585C146.393 200.585 152.143 201.506 156.41 202.804C168.79 206.531 179.12 210.488 191.061 214.236C192.776 212.791 194.136 211.702 195.809 210.216C197.377 208.813 199.97 206.196 200.786 205.442C199.405 204.94 186.691 200.606 183.805 199.622C177.364 197.423 171.236 194.869 164.712 192.88C158.417 190.975 151.181 188.253 144.531 188.253C137.212 187.813 130.896 191.101 124.414 194.22C118.725 196.963 113.205 200.124 107.328 202.511L107.37 202.49Z",
    fill: "#FBF7FF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.37 202.49C110.34 205.484 113.414 208.415 116.613 211.221L118.558 210.278C125.689 206.761 134.347 200.585 142.566 200.585C146.393 200.585 152.143 201.506 156.41 202.804C168.79 206.531 179.12 210.488 191.061 214.236C192.776 212.791 194.136 211.702 195.809 210.216C197.377 208.813 199.97 206.196 200.786 205.442C199.405 204.94 186.691 200.606 183.805 199.622C177.364 197.423 171.236 194.869 164.712 192.88C158.417 190.975 151.181 188.253 144.531 188.253C137.212 187.813 130.896 191.101 124.414 194.22C118.725 196.963 113.205 200.124 107.328 202.511L107.37 202.49Z",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_502_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.0039 53.5045C64.8138 56.7078 59.4393 60.1624 55.0477 63.7216C54.5458 84.0302 56.7416 103.355 61.4678 121.423C67.9716 118.031 68.578 111.604 68.2016 99.4396C67.6788 82.5646 67.0514 68.1811 71.0039 53.5045Z",
    fill: "#FBF7FF"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0039 53.5045C64.8138 56.7078 59.4393 60.1624 55.0477 63.7216C54.5458 84.0302 56.7416 103.355 61.4678 121.423C67.9716 118.031 68.578 111.604 68.2016 99.4396C67.6788 82.5646 67.0514 68.1811 71.0039 53.5045Z",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_502_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.563 39.7491C102.101 41.3403 95.89 43.2037 90.0554 45.2974C85.7266 54.1745 83.8026 62.8632 83.0498 71.2379C80.9585 94.3939 91.1011 125.296 65.8389 135.828C66.8636 138.759 67.951 141.627 69.1012 144.474C118.977 130.07 74.7266 73.6247 108.563 39.7491Z",
    fill: "#FBF7FF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.563 39.7491C102.101 41.3403 95.89 43.2037 90.0554 45.2974C85.7266 54.1745 83.8026 62.8632 83.0498 71.2379C80.9585 94.3939 91.1011 125.296 65.8389 135.828C66.8636 138.759 67.951 141.627 69.1012 144.474C118.977 130.07 74.7266 73.6247 108.563 39.7491Z",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_502_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.27 136.707L246.605 135.702L244.994 135.576C226.55 134.215 211.744 129.798 199.698 122.03C189.116 115.205 182.153 106.621 178.451 95.7548C177.217 92.1537 176.213 88.8247 175.21 85.6005C170.672 70.7773 167.388 60.0577 153.335 60.0577C139.282 60.0577 133.029 68.7674 133.029 86.7101C134.723 131.389 166.636 160.91 227.909 174.498L228.285 174.581L228.85 173.639L229.247 173.011C229.77 172.153 230.272 171.231 230.774 170.289C230.795 170.247 230.816 170.206 230.837 170.164C231.443 169.012 232.05 167.84 232.635 166.667C232.928 166.102 233.2 165.537 233.493 164.971C233.806 164.364 234.099 163.778 234.392 163.234L234.768 162.501L235.186 161.726L235.709 160.742L233.953 160.428C208.481 155.948 186.921 147.133 171.634 134.948C154.402 121.214 146.309 102.266 148.212 80.1151C148.567 76.0952 150.909 74.6715 153.001 74.6715C155.322 74.6715 158.103 76.4512 159.065 80.4291C167.744 116.566 184.432 140.706 240.707 149.311L241.293 149.415L241.711 148.306L241.837 148.013L242.422 146.652C243.008 145.291 243.489 144.139 243.97 142.967C244.555 141.564 245.099 140.099 245.768 138.193L245.914 137.733L246.291 136.686L246.27 136.707Z",
    fill: "#FBF7FF"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M246.27 136.707L246.605 135.702L244.994 135.576C226.55 134.215 211.744 129.798 199.698 122.03C189.116 115.205 182.153 106.621 178.451 95.7548C177.217 92.1537 176.213 88.8247 175.21 85.6005C170.672 70.7773 167.388 60.0577 153.335 60.0577C139.282 60.0577 133.029 68.7674 133.029 86.7101C134.723 131.389 166.636 160.91 227.909 174.498L228.285 174.581L228.85 173.639L229.247 173.011C229.77 172.153 230.272 171.231 230.774 170.289C230.795 170.247 230.816 170.206 230.837 170.164C231.443 169.012 232.05 167.84 232.635 166.667C232.928 166.102 233.2 165.537 233.493 164.971C233.806 164.364 234.099 163.778 234.392 163.234L234.768 162.501L235.186 161.726L235.709 160.742L233.953 160.428C208.481 155.948 186.921 147.133 171.634 134.948C154.402 121.214 146.309 102.266 148.212 80.1151C148.567 76.0952 150.909 74.6715 153.001 74.6715C155.322 74.6715 158.103 76.4512 159.065 80.4291C167.744 116.566 184.432 140.706 240.707 149.311L241.293 149.415L241.711 148.306L241.837 148.013L242.422 146.652C243.008 145.291 243.489 144.139 243.97 142.967C244.555 141.564 245.099 140.099 245.768 138.193L245.914 137.733L246.291 136.686L246.27 136.707Z",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.08,
    cy: 277.009,
    rx: 21.7341,
    ry: 5.5186,
    fill: "#F0F0F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_502_942",
    x: 75.0391,
    y: 34.2777,
    width: 181.599,
    height: 158.699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.29828,
    dy: -2.63863
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_942"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_502_942",
    x: 128.189,
    y: 215.835,
    width: 47.5322,
    height: 22.4183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.29828,
    dy: -2.63863
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_942"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_502_942",
    x: 107.157,
    y: 187.913,
    width: 94.1934,
    height: 26.6576,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.29828,
    dy: -2.63863
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_942"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_502_942",
    x: 54.6777,
    y: 52.9252,
    width: 16.793,
    height: 68.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.29828,
    dy: -2.63863
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_942"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_502_942",
    x: 65.4619,
    y: 39.2009,
    width: 44.0723,
    height: 105.637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.29828,
    dy: -2.63863
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_942"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_502_942",
    x: 132.729,
    y: 59.7577,
    width: 114.298,
    height: 115.163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.29828,
    dy: -2.63863
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_942"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigidBigIdIllustration);
export default __webpack_public_path__ + "static/media/bigid-big-id-illustration.225d5d37dc7c0c8b273404c45a1e56b9.svg";
export { ForwardRef as ReactComponent };